export default {
  NOT: '-'
}